import { render, staticRenderFns } from "./netError.vue?vue&type=template&id=2d55c270&scoped=true&"
import script from "./netError.vue?vue&type=script&lang=js&"
export * from "./netError.vue?vue&type=script&lang=js&"
import style0 from "./netError.vue?vue&type=style&index=0&id=2d55c270&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d55c270",
  null
  
)

export default component.exports